import { combineReducers } from "redux";
import auth from "./AuthReducers";
const rootReducer = combineReducers({
    auth, // you might be used to: counter: counter,
  });
  
  export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js